import api_assurance from '../../../api/clinique/_assurances'

export default {
    getSouscripteurGroupByAssurance(data) {
        return new Promise((resolve, reject) => {
            api_assurance.getSouscripteurGroupByAssurance(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateSouscripteursForfaitaires(data) {
        return new Promise((resolve, reject) => {
            api_assurance.updateSouscripteursForfaitaires(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateMontantForfaitaire(data) {
        return new Promise((resolve, reject) => {
            api_assurance.updateMontantForfaitaire(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateInfoSociete(data) {
        return new Promise((resolve, reject) => {
            api_assurance.updateInfoSociete(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getInfoSocieteByID(societe_id) {
        return new Promise((resolve, reject) => {
            api_assurance.getInfoSocieteByID(societe_id).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}